import React, { useRef, useState } from "react";
import { cognitoUserToken } from "../../helpers/userHelper";
import {
  ROW_COUNT,
} from "../../helpers/variableHelper";
import { usePromiseEffect } from "../../helpers/promiseEffect";
import {
  AdminListaPagination,
  IPagination,
} from "../../controls/AdminListaPagination";
import { CellContext, createColumnHelper } from "@tanstack/react-table";
import { ITipo_Campo } from "../../helpers/IFormHelper";
import { UsuariosExternosServices } from "../../services/UsuariosExternosServices";
import { Row } from "react-bootstrap";
import { IRolesUsuario } from "../../entities/IRolesUsuario";
import AgregarRolUsuario from "./AgregarRolUsuario";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import RenderTitle from "../../controls/RenderTitle";
import RenderValue from "../../controls/RenderValue";
const MySwal = withReactContent(Swal);

interface AdminRolUsuarioTest {
  items?: Array<IRolesUsuario>;
}

const AdminRolUsuario = ({ items }: AdminRolUsuarioTest) => {
  const userInfo = cognitoUserToken();
  const [token, setToken] = useState("");
  const [listItems, setListItems] = useState<Array<IRolesUsuario>>(items || []);
  const [showModalAddUser, setShowModalAddUser] = useState(false);
  const [userEdit, setUserEdit] = useState<IRolesUsuario | null>(null);
  const totalPagesTable = useRef<number>(0);
  const component = (titulo: string) => {
    return <RenderTitle title={titulo} />;
  };

  const componentValue = (value: any) => {
    return <RenderValue value={value} />;
  };

  const componentAcciones = (info: any) => {
    return <div>
      <i
        className="bi bi-search iconSearch colorAzul pointer"
        title="Ver Desviación"
        onClick={() => {
          setUserEdit(info.row.original);
          setShowModalAddUser(true);
        }}
      ></i>
      <i
        className="bi bi-trash iconTrash"
        title="Eliminar Roles"
        onClick={() => {
          MySwal.fire({
            html: (
              <div>
                <h3>
                  ¿Desea eliminar los roles del usuario {info.row.original.DISPLAY_NAME}?
                </h3>
              </div>
            ),
            text: "",
            icon: "question",
            confirmButtonText: "Aceptar",
            cancelButtonText: "Cancelar",
            showCloseButton: true,
            showCancelButton: true,
          }).then(async (result) => {
            if (result.isConfirmed) {
              await UsuariosExternosServices.deleteRolesUsuario(token, info.row.original.EMAIL);
              filter();
            }
          });
        }}
      ></i>
    </div>;
  };
  usePromiseEffect(async () => {
    let token = await userInfo;
    setToken(token);
    filter();
  }, []);

  const filter = async (filter?: IPagination) => {
    const pagination: IPagination = filter || {
      ORDENADOPOR: "ID",
      ORIENTACION: "ASC",
      PAGINA: 1,
      PAGINADO: ROW_COUNT,
    };
    let result = await UsuariosExternosServices.getAllRolesUsuario(
      token,
      pagination
    );
    setListItems(result.data);
    totalPagesTable.current = result.pages;
  };

  const columnHelperTblUsuarios = createColumnHelper<IRolesUsuario>();
  let columnsDefTblUsuarios = [
    columnHelperTblUsuarios.accessor((row) => row.DISPLAY_NAME, {
      id: "USUARIO_DISPLAY",
      cell: (info: CellContext<IRolesUsuario, string>) => (
        componentValue(info.getValue())
      ),
      header: () => component("Nombre Usuario"),
      tipo: ITipo_Campo.text,
    } as any),

    columnHelperTblUsuarios.accessor((row) => row.MODULO, {
      id: "MODULO",
      cell: (info: CellContext<IRolesUsuario, string>) => (
        componentValue(info.getValue())
      ),
      header: () => component("Módulo"),
      tipo: ITipo_Campo.text,
    } as any),

    columnHelperTblUsuarios.accessor((row) => row.ROL, {
      id: "ROL",
      cell: (info: CellContext<IRolesUsuario, string>) => (
        componentValue(info.getValue())
      ),
      header: () => component("Rol"),
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperTblUsuarios.accessor((row) => row.ID, {
      id: "ACCIONES",
      cell: (info: CellContext<IRolesUsuario, string>) => (
        componentAcciones(info)
      ),
      header: () => component("Acciones"),
      tipo: ITipo_Campo.text,
      disableSorting: true,
    } as any),
  ] as any;

  return (
    <div className="rounded bg-white p-2 shadow">
      <div className="container-fluid mb-4">
        <Row>
          <h1 className="titPrincipal colorTit">Administración de Roles</h1>
          <div className="container-fluid mb-4">
            <button
              type="button"
              className="btn btn-sm btn-primary"
              data-bs-toggle="offcanvas"
              data-bs-target="#offPanelCrearUsuario"
              aria-controls="offPanelCrearUsuario"
              onClick={() => {
                setShowModalAddUser(true);
              }}
            >
              {" "}
              <i className="bi bi-plus-circle me-2"></i>Agregar Rol Usuario
            </button>
          </div>
        </Row>

        <AdminListaPagination
          defaultSortBy="ID"
          sortDirection="ASC"
          totalPages={totalPagesTable}
          resultPerPage={ROW_COUNT}
          callback={filter}
          data={listItems}
          reload={() => { filter(); }}
          columnsDef={columnsDefTblUsuarios}
          hideAdd={true}
          hideExport={true}
        />
        {showModalAddUser && (
          <AgregarRolUsuario
            show={showModalAddUser}
            rolUsuarioEdit={userEdit}
            onClose={() => {
              setUserEdit(null);
              setShowModalAddUser(false);
              filter();
            }}
          />
        )}
      </div>
    </div>
  );
};

export default AdminRolUsuario;
